import { useState } from 'react'
import { unassignedQuery } from '../api/opteemum'
import { DeviceWorkspace } from '../devices/DeviceWorkspace'
import { unassignedColumns } from './columns'
import { OpteemumTablePage } from './TablePage'
import { UnassignedMatch } from './UnassignedMatch'

/**
 * Randul desfacut din Unassigned - `Opteemum::getUnassignedActionTabs`
 * (`unassigned/actionsTabs.php`): filele `ul.action_tabs`. „Device Details"
 * deschide fisa aparatului (unde sta si Assign - Agent Settings, Assignment);
 * „Match" e `Opteemum::matchedDevices`. Serverul tine dreptul
 * (`opteemum.unassigned_match.read`), fila arata refuzul lui.
 */
function UnassignedDetails({ id }: { id: number }) {
  const [tab, setTab] = useState<'details' | 'match'>('details')
  return (
    <div className="row d-flex m-0">
      <div className="col-auto bg-lightest-gray">
        <ul className="action_tabs">
          <li>
            <a
              href={`/app/opteemum/deviceDetails/${id}`}
              className={tab === 'details' ? 'action_button active' : 'action_button'}
              onClick={(e) => {
                e.preventDefault()
                setTab('details')
              }}
            >
              Device Details
            </a>
          </li>
          <li>
            <a
              href={`/app/opteemum/matchedDevices/${id}`}
              className={tab === 'match' ? 'action_button active' : 'action_button'}
              onClick={(e) => {
                e.preventDefault()
                setTab('match')
              }}
            >
              Match
            </a>
          </li>
        </ul>
      </div>
      <div className="col-md-12">
        <div className="details_content">{tab === 'match' ? <UnassignedMatch id={id} /> : <DeviceWorkspace id={id} from="opteemum" />}</div>
      </div>
    </div>
  )
}

export function UnassignedPage() {
  return (
    <OpteemumTablePage
      id="unnasignedDevices"
      columns={unassignedColumns()}
      queryOf={unassignedQuery}
      details={(row) => <UnassignedDetails id={Number(row.ID ?? row.deviceId)} />}
      rowKey={(r) => Number(r.ID ?? r.deviceId)}
    />
  )
}
